import { List } from '@/components/atoms/List/render';
import { Paragraph } from '@/components/atoms/Paragraph/render';
import { Image } from '@/components/molecules/Image/render';
import { ListButtons } from '@/components/molecules/ListButtons/render';

import { ButtonPrimary, ButtonSecondary } from '@/components/atoms/renders';

const blocksList = {
	[ButtonPrimary.slug]: ButtonPrimary,
	[ButtonSecondary.slug]: ButtonSecondary,
	[Image.slug]: Image,
	[Paragraph.slug]: Paragraph,
	[List.slug]: ({ children, ordered, ...props }) => {
		// this is a hack after update, because the List component was not able to render the children
		return (
			<List
				{...props}
				ordered={ordered}
				values={children?.props?.blocks
					?.map((block) => `<li>${block.attributes.content}</li>`)
					.join('')}
			/>
		);
	},
	[ListButtons.slug]: ListButtons,
};

export default function AccordionChildren({ blocks }) {
	return (
		<>
			{blocks.map(({ name, ...props }, i) => {
				if (!!blocksList[name]) {
					const Block = blocksList[name];

					return (
						<Block key={i} {...props.attributes} slug={name}>
							{props.innerBlocks && (
								<AccordionChildren blocks={props.innerBlocks} />
							)}
						</Block>
					);
				} else {
					return null;
				}
			})}
		</>
	);
}
